import { Component, OnInit } from "@angular/core";
import { Title, Meta, DomSanitizer } from "@angular/platform-browser";
import { Platform } from "src/app/platform.service";
import { ViewportScroller } from "@angular/common";
import { AnimationBuilder } from "@angular/animations";
import { Router } from "@angular/router";

@Component({
	templateUrl: "./component.html"
})
export class GoodPage implements OnInit {
	constructor(
		private title: Title,
		private meta: Meta,
		public platform: Platform,
		public sanitizer: DomSanitizer,
		public viewportScroller: ViewportScroller,
		public animationBuilder: AnimationBuilder,
		public router: Router
	) {}

	ngOnInit(): void {
		this.title.setTitle(
			"Identity, design, development, and video | Fathom for good"
		);
		this.meta.updateTag({
			property: "og:title",
			content:
				"Identity, design, development, and video | Fathom for good"
		});
		this.meta.updateTag({
			name: "description",
			content:
				"Fathom knows fundraising—and, we know how to help heroes soar to new heights. Keep your energy focused on the cause and we'll take care of the rest: capital campaign websites, online giving, printed materials, nonprofit identity, videos, and more."
		});
		this.meta.updateTag({
			property: "og:description",
			content:
				"Fathom knows fundraising—and, we know how to help heroes soar to new heights. Keep your energy focused on the cause and we'll take care of the rest: capital campaign websites, online giving, printed materials, nonprofit identity, videos, and more."
		});
		this.meta.updateTag({
			property: "og:image",
			content: "/assets/images/ogp/good.png"
		});
	}
}
